import React from 'react';
import { useAppContext } from '../shared/AppContext';
import { useTemplateSyncController } from './hooks/useTemplateSyncController';
import TemplateSyncView from './components/TemplateSyncView';

const TemplateSync: React.FC = () => {
    const app = useAppContext();
    const ctrl = useTemplateSyncController();

    if (!app.loginUser) {
        return <div></div>;
    }

    if (!ctrl.isSuper) {
        return (
            <div className="container-fluid" style={{ padding: '20px' }}>
                <h4>Access Denied</h4>
                <p>You do not have permission to view this page.</p>
            </div>
        );
    }

    return <TemplateSyncView {...ctrl} />;
};

export default TemplateSync;
